import { SizeGridItem } from '@generated-client/backend';

export const NB_WIDTH_TABLE_MALE: SizeGridItem[] = [
  { key: 'Значение', value: '2A,B,D,2E,4E,6E' },
  {
    key: 'Ширина',
    value: 'Очень узкая,Узкая,Стандартная,Широкая,Очень широкая,Самая широкая',
  },
];

export const NB_WIDTH_TABLE_FEMALE: SizeGridItem[] = [
  { key: 'Значение', value: '4A,2A,B,D,2E,4E' },
  {
    key: 'Ширина',
    value: 'Очень узкая,Узкая,Стандартная,Широкая,Очень широкая,Самая широкая',
  },
];
